import Slider from '@components/v2/form/Slider/Slider';
import { Control, Controller } from 'react-hook-form';
import { NpsScoreFormValues } from '../nps.schema';
import { npsMarks } from '../nps.utils';

const SLIDER_STEP = 10;
const SLIDER_MIN = 0;
const SLIDER_MAX = 100;

interface NpsSliderProps {
  control: Control<NpsScoreFormValues>;
  name: 'score';
}

const NpsSlider = ({ control, name }: NpsSliderProps) => (
  <Controller
    name={name}
    control={control}
    render={({ field }) => (
      <Slider
        value={field.value ?? SLIDER_MIN}
        onChange={(_, value) => field.onChange(value)}
        onBlur={field.onBlur}
        min={SLIDER_MIN}
        max={SLIDER_MAX}
        step={SLIDER_STEP}
        marks={npsMarks}
        size="small"
      />
    )}
  />
);

export default NpsSlider;
